export default "__VITE_ASSET__cbee70b0__"